module.exports = __webpack_public_path__ + "img/plats.6e8772ae.png";